import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SimulatorService {

  url: string = environment.api.endpoint;

  constructor(private http: HttpClient) { }

  create(form: any): any{
    return this.http.post(`${this.url}/simulator/create`, form);
  }

  update(id: string, data: any): any{
    return this.http.post(`${this.url}/simulator/update/${id}`, data);
  }

  delete(data): any{
    return this.http.post(`${this.url}/simulator/delete`, data);
  }

  getAllByOrganization(filter: any): any {
    return this.http.get(`${this.url}/simulators/organization`, { params: filter });
  }
}
